import { render } from "./ProductsPage.vue?vue&type=template&id=c26d1482"
import script from "@/assets/js/products.js?vue&type=script&defer=true&lang=js&external"
export * from "@/assets/js/products.js?vue&type=script&defer=true&lang=js&external"

import "@/assets/css/products.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__